/**
 * Aktionsleiste der SuggestionCard: Übernehmen/Bearbeiten/Neu generieren/Verwerfen.
 * Ausgelagert, damit die Card unter dem Component-Size-Limit bleibt (T7).
 */
import { Check, Pencil, RotateCw, Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { EID } from '@/lib/element-ids.registry'

import { DV2 } from './tokens'

export interface SuggestionCardActionsProps {
  idSuffix: string
  busy: boolean
  onApply: () => void
  onDiscard: () => void
  onEdit?: () => void
  onRegenerate?: () => void
}

export function SuggestionCardActions({
  idSuffix,
  busy,
  onApply,
  onDiscard,
  onEdit,
  onRegenerate,
}: SuggestionCardActionsProps) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-wrap items-center gap-2 pt-1">
      <button
        type="button"
        id={`${EID['optimierung-card-apply-btn']}-${idSuffix}`}
        onClick={onApply}
        disabled={busy}
        className={`flex items-center gap-1.5 rounded-md ${DV2.orangeBg} px-3 py-1.5 text-xs font-semibold text-black disabled:opacity-50`}
      >
        <Check size={12} />
        {t('channelContent.card.apply')}
      </button>
      {onEdit && (
        <button
          type="button"
          id={`${EID['optimierung-card-edit-btn']}-${idSuffix}`}
          onClick={onEdit}
          disabled={busy}
          className={`flex items-center gap-1.5 rounded-md border ${DV2.lineStrong} px-3 py-1.5 text-xs font-semibold ${DV2.fg1} disabled:opacity-50`}
        >
          <Pencil size={12} />
          {t('channelContent.card.edit')}
        </button>
      )}
      {onRegenerate && (
        <button
          type="button"
          id={`${EID['optimierung-card-regenerate-btn']}-${idSuffix}`}
          onClick={onRegenerate}
          disabled={busy}
          className={`flex items-center gap-1.5 rounded-md border ${DV2.lineStrong} px-3 py-1.5 text-xs font-semibold ${DV2.fg1} disabled:opacity-50`}
        >
          <RotateCw size={12} />
          {t('channelContent.card.regenerate')}
        </button>
      )}
      <button
        type="button"
        id={`${EID['optimierung-card-discard-btn']}-${idSuffix}`}
        onClick={onDiscard}
        disabled={busy}
        className={`flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs ${DV2.fg4} hover:${DV2.fg2} disabled:opacity-50`}
      >
        <Trash2 size={12} />
        {t('channelContent.card.discard')}
      </button>
    </div>
  )
}
